import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as OT from '@opentok/client';
import { environment } from "@environments/environment";

@Injectable()
export class OpentokService {

  videoCallSlot;
  session: OT.Session;
  token: string;

  constructor(public http: HttpClient) { }

  getOT() {
    return OT;
  }

  getSessionConfig(room) {
    if (environment.VIDEOCALL.HAS) {
      let url = environment.VIDEOCALL.SERVERURL + '/room/' + room;
      return this.http.get(url);
    }
  }

  initSession(apiKey, token, sessionId) {
    if (environment.VIDEOCALL.HAS) {
      if (apiKey && token && sessionId) {
        this.session = this.getOT().initSession(apiKey, sessionId);
        this.token = token;
        return Promise.resolve(this.session);
      } else {
        return fetch(environment.VIDEOCALL.SERVERURL + '/session')
          .then((data) => data.json())
          .then((json) => {
            this.session = this.getOT().initSession(json.apiKey, json.sessionId);
            this.token = json.token;
            return this.session;
          });
      }
    }
  }

  handleError(error) {
    if (error) {
      alert(error.message);
    }
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.session.connect(this.token, (err) => {
        if (err) {
          reject(err);
        } else {
          resolve(this.session);
        }
      });
    });
  }
}